import { render } from "./IconFolderFilled.vue?vue&type=template&id=600a43c2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolderFilled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "600a43c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('600a43c2', __exports__)) {
    api.reload('600a43c2', __exports__)
  }
  
  module.hot.accept("./IconFolderFilled.vue?vue&type=template&id=600a43c2", () => {
    api.rerender('600a43c2', render)
  })

}


export default __exports__